(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-schedule', {
            parent: 'entity',
            url: '/event-schedule?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventSchedule.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-schedule/event-schedules.html',
                    controller: 'EventScheduleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventSchedule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-schedule-detail', {
            parent: 'entity',
            url: '/event-schedule/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventSchedule.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-schedule/event-schedule-detail.html',
                    controller: 'EventScheduleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventSchedule');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventSchedule', function($stateParams, EventSchedule) {
                    return EventSchedule.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-schedule.new', {
            parent: 'event-schedule',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-schedule/event-schedule-dialog.html',
                    controller: 'EventScheduleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startedAt: null,
                                finishedAt: null,
                                reminder: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-schedule', null, { reload: true });
                }, function() {
                    $state.go('event-schedule');
                });
            }]
        })
        .state('event-schedule.edit', {
            parent: 'event-schedule',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-schedule/event-schedule-dialog.html',
                    controller: 'EventScheduleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventSchedule', function(EventSchedule) {
                            return EventSchedule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-schedule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-schedule.delete', {
            parent: 'event-schedule',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-schedule/event-schedule-delete-dialog.html',
                    controller: 'EventScheduleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventSchedule', function(EventSchedule) {
                            return EventSchedule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-schedule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
